import React from 'react';
import Logs from 'components/Logs';

const DealerBusinessLogs = ({ id }) => {
  return (
    <Logs
      targetId={parseInt(id)}
      targetType={'BusinessUserGroup'}
      title="Dealer Logs"
      height={439}
    />
  );
};

export default DealerBusinessLogs;
